import { gql } from '@apollo/client';

const STOP_HOLTER_STUDY_PROCESSING = gql`
  mutation stopHolterStudyProcessing($input: HolterStudyProcessingInput!) {
    stopHolterStudyProcessing(input: $input) {
      isSuccess
      message
    }
  }
`;

export default STOP_HOLTER_STUDY_PROCESSING;
